import { getPhonebookProfilePath } from "@/common/helpers/get-phonebook-profile-path";
import { cn } from "@/common/helpers/utils";
import { ArrowUpRightIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { UserItem, type UserItemProps, UserItemVariant } from "./user-item";

export type PhonebookUserItemProps = Omit<UserItemProps, "to">;

export function PhonebookUserItem({
  user,
  variant = UserItemVariant.Default,
  className,
  endContent,
  tooltip,
  ...props
}: PhonebookUserItemProps) {
  const { t } = useTranslation("phonebook");
  const clickableClassName =
    variant === UserItemVariant.Compact
      ? "group inline-flex w-fit max-w-full rounded-sm text-foreground transition-colors hover:text-primary"
      : "border-primary/30 hover:border-primary/70 hover:bg-primary/5";
  const profileLinkIndicator =
    variant === UserItemVariant.Compact ? (
      <ArrowUpRightIcon
        className="text-muted-foreground/70 group-hover:text-primary size-3.5 transition-colors"
        aria-hidden
      />
    ) : null;

  return (
    <UserItem
      {...props}
      user={user}
      variant={variant}
      to={`~${getPhonebookProfilePath(user.uuid)}`}
      endContent={
        profileLinkIndicator ? (
          <>
            {endContent}
            {profileLinkIndicator}
          </>
        ) : (
          endContent
        )
      }
      tooltip={tooltip ?? t("ViewProfile")}
      className={cn(clickableClassName, className)}
    />
  );
}
